// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultiSelect_field__sswZy {
  position: relative;
}

.MultiSelect_label__cyS0h {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
  margin-bottom: 6px;
}

.MultiSelect_control__otfVM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 42px;
  padding: 8px 12px;
  background: var(--dylo-field-bg);
  border: 1px solid var(--dylo-field-border);
  border-radius: 10px;
  cursor: pointer;
  font-family: var(--font-sans);
  font-size: 14px;
  color: var(--dylo-ink);
  text-align: left;
}
.MultiSelect_control__otfVM:focus-visible {
  outline: 2px solid var(--dylo-teal-500);
}
.MultiSelect_placeholder__r7s5h {
  color: var(--dylo-muted);
}
.MultiSelect_chevron__oZykd {
  color: var(--dylo-field-icon);
  flex-shrink: 0;
  transition: transform 0.15s ease;
}
.MultiSelect_open__SzbJa .MultiSelect_chevron__oZykd {
  transform: rotate(180deg);
}

.MultiSelect_count__YRPKv {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: var(--dylo-teal-700);
  color: #fff;
  font-size: 11.5px;
  font-weight: 700;
}

.MultiSelect_menu__IdkfR {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  background: var(--dylo-surface);
  border: 1px solid var(--dylo-surface-border);
  border-radius: 10px;
  box-shadow: var(--shadow-card);
  z-index: 20;
  overflow: hidden;
  transform-origin: top center;
  animation: MultiSelect_dylo-dropdown__59pjL 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@media (prefers-reduced-motion: reduce) {
  .MultiSelect_menu__IdkfR { animation: none; }
}

.MultiSelect_search__Z3RaF {
  width: 100%;
  border: none;
  border-bottom: 1px solid var(--dylo-line);
  padding: 10px 12px;
  background: transparent;
  color: var(--dylo-ink);
  font-family: var(--font-sans);
  font-size: 13.5px;
  outline: none;
}
.MultiSelect_search__Z3RaF::placeholder {
  color: var(--dylo-muted);
}

.MultiSelect_list__hDaBz {
  max-height: 200px;
  overflow-y: auto;
  padding: 4px;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.MultiSelect_list__hDaBz::-webkit-scrollbar {
  width: 6px;
}
.MultiSelect_list__hDaBz::-webkit-scrollbar-track {
  background: transparent;
}
.MultiSelect_list__hDaBz::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.MultiSelect_list__hDaBz::-webkit-scrollbar-thumb:hover {
  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);
}

.MultiSelect_option__YbcRU {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  background: transparent;
  color: var(--dylo-text);
  font-family: var(--font-sans);
  font-size: 13.5px;
  text-align: left;
  cursor: pointer;
  border-radius: 8px;
  animation: MultiSelect_dylo-fade-in__gy6jv 0.22s ease both;
}
.MultiSelect_option__YbcRU:nth-child(1) { animation-delay: 0.02s; }
.MultiSelect_option__YbcRU:nth-child(2) { animation-delay: 0.04s; }
.MultiSelect_option__YbcRU:nth-child(3) { animation-delay: 0.06s; }
.MultiSelect_option__YbcRU:nth-child(4) { animation-delay: 0.08s; }
.MultiSelect_option__YbcRU:nth-child(5) { animation-delay: 0.10s; }
.MultiSelect_option__YbcRU:nth-child(6) { animation-delay: 0.12s; }
.MultiSelect_option__YbcRU:nth-child(7) { animation-delay: 0.14s; }
.MultiSelect_option__YbcRU:nth-child(8) { animation-delay: 0.16s; }
@media (prefers-reduced-motion: reduce) {
  .MultiSelect_option__YbcRU { animation: none; }
}
.MultiSelect_option__YbcRU:hover {
  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);
}

.MultiSelect_check__1rB9X {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1.5px solid var(--dylo-field-border);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}
.MultiSelect_checked__SCT2w {
  background: var(--dylo-teal-700);
  border-color: var(--dylo-teal-700);
}

.MultiSelect_emptyOpt__vxk3G {
  padding: 12px;
  text-align: center;
  color: var(--dylo-muted);
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/MultiSelect/MultiSelect.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,+BAA+B;EAC/B,4CAA4C;EAC5C,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,mFAAgE;AAClE;AACA;EACE,2BAAQ,eAAe,EAAE;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0DAAuC;AACzC;AACA,0CAAuB,sBAAsB,EAAE;AAC/C,0CAAuB,sBAAsB,EAAE;AAC/C,0CAAuB,sBAAsB,EAAE;AAC/C,0CAAuB,sBAAsB,EAAE;AAC/C,0CAAuB,sBAAsB,EAAE;AAC/C,0CAAuB,sBAAsB,EAAE;AAC/C,0CAAuB,sBAAsB,EAAE;AAC/C,0CAAuB,sBAAsB,EAAE;AAC/C;EACE,6BAAU,eAAe,EAAE;AAC7B;AACA;EACE,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".field {\n  position: relative;\n}\n\n.label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n  margin-bottom: 6px;\n}\n\n.control {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 42px;\n  padding: 8px 12px;\n  background: var(--dylo-field-bg);\n  border: 1px solid var(--dylo-field-border);\n  border-radius: 10px;\n  cursor: pointer;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  color: var(--dylo-ink);\n  text-align: left;\n}\n.control:focus-visible {\n  outline: 2px solid var(--dylo-teal-500);\n}\n.placeholder {\n  color: var(--dylo-muted);\n}\n.chevron {\n  color: var(--dylo-field-icon);\n  flex-shrink: 0;\n  transition: transform 0.15s ease;\n}\n.open .chevron {\n  transform: rotate(180deg);\n}\n\n.count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 10px;\n  background: var(--dylo-teal-700);\n  color: #fff;\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n.menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 4px);\n  background: var(--dylo-surface);\n  border: 1px solid var(--dylo-surface-border);\n  border-radius: 10px;\n  box-shadow: var(--shadow-card);\n  z-index: 20;\n  overflow: hidden;\n  transform-origin: top center;\n  animation: dylo-dropdown 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n@media (prefers-reduced-motion: reduce) {\n  .menu { animation: none; }\n}\n\n.search {\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid var(--dylo-line);\n  padding: 10px 12px;\n  background: transparent;\n  color: var(--dylo-ink);\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  outline: none;\n}\n.search::placeholder {\n  color: var(--dylo-muted);\n}\n\n.list {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.list::-webkit-scrollbar {\n  width: 6px;\n}\n.list::-webkit-scrollbar-track {\n  background: transparent;\n}\n.list::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.list::-webkit-scrollbar-thumb:hover {\n  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  background: transparent;\n  color: var(--dylo-text);\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  text-align: left;\n  cursor: pointer;\n  border-radius: 8px;\n  animation: dylo-fade-in 0.22s ease both;\n}\n.option:nth-child(1) { animation-delay: 0.02s; }\n.option:nth-child(2) { animation-delay: 0.04s; }\n.option:nth-child(3) { animation-delay: 0.06s; }\n.option:nth-child(4) { animation-delay: 0.08s; }\n.option:nth-child(5) { animation-delay: 0.10s; }\n.option:nth-child(6) { animation-delay: 0.12s; }\n.option:nth-child(7) { animation-delay: 0.14s; }\n.option:nth-child(8) { animation-delay: 0.16s; }\n@media (prefers-reduced-motion: reduce) {\n  .option { animation: none; }\n}\n.option:hover {\n  background: color-mix(in srgb, var(--dylo-teal-700) 10%, transparent);\n}\n\n.check {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  border: 1.5px solid var(--dylo-field-border);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #fff;\n}\n.checked {\n  background: var(--dylo-teal-700);\n  border-color: var(--dylo-teal-700);\n}\n\n.emptyOpt {\n  padding: 12px;\n  text-align: center;\n  color: var(--dylo-muted);\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `MultiSelect_field__sswZy`,
	"label": `MultiSelect_label__cyS0h`,
	"control": `MultiSelect_control__otfVM`,
	"placeholder": `MultiSelect_placeholder__r7s5h`,
	"chevron": `MultiSelect_chevron__oZykd`,
	"open": `MultiSelect_open__SzbJa`,
	"count": `MultiSelect_count__YRPKv`,
	"menu": `MultiSelect_menu__IdkfR`,
	"dylo-dropdown": `MultiSelect_dylo-dropdown__59pjL`,
	"search": `MultiSelect_search__Z3RaF`,
	"list": `MultiSelect_list__hDaBz`,
	"option": `MultiSelect_option__YbcRU`,
	"dylo-fade-in": `MultiSelect_dylo-fade-in__gy6jv`,
	"check": `MultiSelect_check__1rB9X`,
	"checked": `MultiSelect_checked__SCT2w`,
	"emptyOpt": `MultiSelect_emptyOpt__vxk3G`
};
export default ___CSS_LOADER_EXPORT___;
